"use client";

import { GoogleTagManager } from "@next/third-parties/google";
import usePageViewTracker from "@/hooks/usePageViewTracker";
import useScrollDepthTracker from "@/hooks/useScrollDepthTracker";
import useTimeOnPageTracker from "@/hooks/useTimeOnPageTracker";

export default function Analytics() {
  const gtmId = process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER;
  const isDev =
    process.env.NODE_ENV === "development" &&
    process.env.NEXT_PUBLIC_ANALYTICS_DEV !== "true";

  usePageViewTracker({ requestPerms: false });
  useScrollDepthTracker();
  useTimeOnPageTracker();

  if (isDev) return null;

  return gtmId ? <GoogleTagManager gtmId={gtmId} /> : null;
}
